<script setup>
import { Link } from '@inertiajs/vue3';
import { ArrowLongLeftIcon, ArrowLongRightIcon } from '@heroicons/vue/20/solid';

defineProps({
    linkCollection: {
        type: Array,
        required: true,
    },
});

const linkClasses = 'inline-flex items-center border-t-2 px-4 pt-4 text-sm font-semibold';
</script>

<template>
    <nav class="flex items-center justify-between border-t border-gray-200 px-4 sm:px-0">
        <div
            v-for="(link, index) in linkCollection"
            :key="index"
            :class="{
                '-mt-px flex w-0 flex-1': index === 0,
                '-mt-px flex w-0 flex-1 justify-end': index === Object.keys(linkCollection).length-1,
                'hidden md:-mt-px md:flex': index !== 0 && index !== Object.keys(linkCollection).length-1,
            }"
        >
            <Component
                :is="!link.url ? 'span' : Link"
                v-if="link.label !== '...'"
                :href="link.url ?? null"
                :class="[
                    linkClasses,
                    link.active ? 'border-sunset-orange-500 text-sunset-orange-500' : 'border-transparent text-gray-500 hover:text-sunset-orange-500 hover:border-sunset-orange-300'
                ]"
                :aria-current="link.active ? 'page' : null"
            >
                <ArrowLongLeftIcon
                    v-if="index === 0"
                    class="mr-3 h-5 w-5"
                    aria-hidden="true"
                />

                {{ link.label }}

                <ArrowLongRightIcon
                    v-if="index === Object.keys(linkCollection).length-1"
                    class="ml-3 h-5 w-5"
                    aria-hidden="true"
                />
            </Component>

            <span
                v-else
                class="border-transparent text-gray-500"
                :class="linkClasses"
            >
                {{ link.label }}
            </span>
        </div>
    </nav>
</template>
